// Modules
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HttpModule } from '@angular/http';
import { FacebookModule } from 'ngx-facebook';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { Ng2HighchartsModule } from 'ng2-highcharts';
import { ClipboardModule } from 'ngx-clipboard';
import { Angulartics2Module, Angulartics2GoogleAnalytics } from 'angulartics2';
import "froala-editor/js/froala_editor.pkgd.min.js";
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';

// Routing
import { AppRoutingModule } from './app-routing/app-routing.module';
import { RoleCanActivateRouteGuard } from './app-routing/role-can-activate-route.guard';

// Environment
import { environment } from '../environments/environment';

// Services
import { ApiService } from './api.service';
import { LoaderService } from './loader.service';
import { EnvService } from './env.service';
import { TrainingZonesService } from './training-zones.service';
import { ChartsService } from './charts.service';
import { HubService } from './hub.service';
import { FilesService } from './files.service';

// Components
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { CauthComponent } from './cauth/cauth.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { SessionsComponent } from './sessions/sessions.component';
import { SessionComponent } from './session/session.component';
import { FriendsComponent } from './friends/friends.component';
import { UserComponent } from './user/user.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

// Pipes
import { DurationPipe } from './duration.pipe';
import { DistancePipe } from './distance.pipe';
import { KeysPipe } from './keys.pipe';

// Directives
import { MatchHeightDirective } from './match-height.directive';
import { ErrorComponent } from './error/error.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { BecomeComponent } from './become/become.component';
import { WorkoutEditorComponent } from './workout-editor/workout-editor.component';
import { WorkoutListComponent } from './workout-list/workout-list.component';
import { WorkoutViewComponent } from './workout-view/workout-view.component';
import { SixSecondBoardComponent } from './six-second-board/six-second-board.component';
import { FiveKBoardComponent } from './five-k-board/five-k-board.component';
import { DuplicateAppleId } from './duplicateappleid/duplicateappleid.component';
import { MydataComponent } from './mydata/mydata.component';
import { FooterComponent } from './footer/footer.component';
import { PagesComponent } from './pages/pages.component';
import { BoardsComponent } from './boards/boards.component';
import { AgePipe } from './age.pipe';
import { HtmlPipe } from './html.pipe';
import { BikeModelPipe } from './bike-model.pipe';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { ShareviewComponent } from './shareview/shareview.component';
import { AppStoreLinkComponent } from './app-store-link/app-store-link.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    CauthComponent,
    HeaderComponent,
    HomeComponent,
    SessionsComponent,
    SessionComponent,
    FriendsComponent,
    UserComponent,
    PageNotFoundComponent,
    DurationPipe,
    DistancePipe,
    KeysPipe,
    MatchHeightDirective,
    ErrorComponent,
    LandingPageComponent,
    MaintenanceComponent,
    PasswordResetComponent,
    BecomeComponent,
    WorkoutEditorComponent,
    WorkoutListComponent,
    WorkoutViewComponent,
    SixSecondBoardComponent,
    FiveKBoardComponent,
    DuplicateAppleId,
    MydataComponent,
    FooterComponent,
    PagesComponent,
    BoardsComponent,
    AgePipe,
    HtmlPipe,
    BikeModelPipe,
    CauthComponent,
    MaintenanceComponent,
    ShareviewComponent,
    AppStoreLinkComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    FacebookModule.forRoot(),
    NgxDatatableModule,
    Ng2HighchartsModule,
    ClipboardModule,
    AppRoutingModule,
    Angulartics2Module.forRoot([ Angulartics2GoogleAnalytics ]),
    FroalaEditorModule.forRoot(), FroalaViewModule.forRoot()
  ],
  providers: [
    ApiService,
    LoaderService,
    EnvService,
    TrainingZonesService,
    ChartsService,
    HubService,
    FilesService,
    DurationPipe,
    RoleCanActivateRouteGuard
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/app.module.ts